<script setup lang="ts">
import { useConfigStore } from "@/stores/config";

const config = useConfigStore();
const props = defineProps<{
    companySlug: string;
}>();
</script>

<template>
    <img
        class="company-logo img-fluid"
        :src="`${config.cdnUrl}/logos/annuities/${props.companySlug}.svg`"
        :alt="props.companySlug"
    >
</template>

<style scoped>
.company-logo {
    max-height: 50px;
    width: 100px;
    margin: 15px 0px;
}

@media only screen and (max-width: 991px) {
    .company-logo {
        max-height: 75px;
    }
}
</style>
